<h2 mat-dialog-title>E-Mails senden</h2>

<mat-dialog-content class="email-dialog-content">
  <p class="hint" *ngIf="!recipients.length">
    In der Rollkarte sind keine E-Mail-Adressen hinterlegt (CSV-Spalte „Email“).
  </p>

  <div *ngIf="recipients.length" class="recipient-block">
    <div class="recipient-toolbar">
      <strong>{{ selectedRecipients.length }} / {{ recipients.length }} Empfänger</strong>
      <button type="button" class="btn btn-link btn-sm" (click)="toggleAll(true)">Alle</button>
      <button type="button" class="btn btn-link btn-sm" (click)="toggleAll(false)">Keine</button>
    </div>
    <label class="recipient-item" *ngFor="let item of recipients">
      <input type="checkbox" [(ngModel)]="item.selected" [ngModelOptions]="{ standalone: true }" />
      <span class="recipient-email">{{ item.email }}</span>
      <span class="recipient-meta">{{ item.stop.customerName || item.stop.kaufvertragsnummer }}</span>
    </label>
  </div>

  <form [formGroup]="form" class="email-form">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Betreff</mat-label>
      <input matInput formControlName="title" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nachricht</mat-label>
      <textarea matInput rows="10" formControlName="text"></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn btn-outline-secondary" (click)="close()" [disabled]="sending">Abbrechen</button>
  <button type="button" class="btn btn-primary" (click)="send()" [disabled]="!canSend">
    {{ sending ? 'Sende …' : 'Senden' }}
  </button>
</mat-dialog-actions>
